import { FC, SVGProps } from 'react'

export const Selector: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.6918 4.22676C12.0001 3.92441 12.4999 3.92441 12.8082 4.22676L17.0188 8.35579C17.3271 8.65813 17.3271 9.14832 17.0188 9.45066C16.7105 9.753 16.2106 9.753 15.9023 9.45066L12.25 5.86907L8.59772 9.45066C8.28941 9.753 7.78954 9.753 7.48123 9.45066C7.17292 9.14832 7.17292 8.65813 7.48123 8.35579L11.6918 4.22676ZM7.48123 14.5493C7.78954 14.247 8.28941 14.247 8.59772 14.5493L12.25 18.1309L15.9023 14.5493C16.2106 14.247 16.7105 14.247 17.0188 14.5493C17.3271 14.8517 17.3271 15.3419 17.0188 15.6442L12.8082 19.7732C12.4999 20.0756 12.0001 20.0756 11.6918 19.7732L7.48123 15.6442C7.17292 15.3419 7.17292 14.8517 7.48123 14.5493Z"
			fill="currentColor"
		/>
	</svg>
)
